/* Scoped presentation and selection bridge. Releasit retains order submission. */
(function () {
  'use strict';
  if (!document.body.classList.contains('sp-neocell-v01')) return;
  const money = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
  function syncComparison() {
    const order = document.querySelector('[data-lp-anchor="order"]');
    if (!order) return;
    const offers = Array.from(order.querySelectorAll('[data-lp-pack]'));
    document.querySelectorAll('[data-shp-comparison-row]').forEach(row => {
      const source = offers.find(card => card.dataset.variantId === row.dataset.variantId && card.dataset.quantity === row.dataset.quantity && card.dataset.unitsPerItem === row.dataset.units);
      if (!source) return;
      const total = Number(source.dataset.lpCodTotalCents) / 100;
      const units = Number(source.dataset.quantity) * Number(source.dataset.unitsPerItem);
      if (!(total > 0 && units > 0)) return;
      row.querySelector('[data-shp-total]').textContent = money.format(total);
      row.querySelector('[data-shp-unit]').textContent = (Number.isInteger(total / units) ? '' : 'Aprox. ') + money.format(total / units);
    });
  }
  let offerSession = null;
  let forwardingOfferClick = false;
  const offerRowSelector = '._rsi-quantity-offers-offer-container';
  function offerMode() {
    return document.querySelector('[data-lp-anchor="order"][data-product-id="16345066537041"]')?.dataset.lpCodQuantityOffers === 'true';
  }
  function priceCents(text) {
    const value = (text || '').replace(/[^0-9.,]/g, '');
    if (!/^\d[\d.]*?(?:,\d{1,2})?$/.test(value)) return 0;
    const parts = value.split(',');
    const total = Number(parts[0].replace(/\./g, '')) * 100 + Number((parts[1] || '').padEnd(2, '0'));
    return Number.isSafeInteger(total) && total > 0 ? total : 0;
  }
  function cardOffer(card) {
    if (!card || card.disabled) return null;
    const quantity = Number(card.dataset.quantity) * Number(card.dataset.unitsPerItem || 1);
    const total = Number(card.dataset.lpCodTotalCents);
    const variant = card.dataset.variantId;
    return variant === '62790523813969' && Number.isInteger(quantity) && quantity > 0 && Number.isSafeInteger(total) && total > 0
      ? { variant, quantity, total } : null;
  }
  function selectedLandingOffer() {
    return cardOffer(document.querySelector('[data-lp-anchor="hero"] [data-lp-pack][aria-pressed="true"]'));
  }
  function sameOffer(left, right) {
    return !!left && !!right && left.variant === right.variant && left.quantity === right.quantity && left.total === right.total;
  }
  function appOffer(row, requireInputs = true) {
    if (!row) return null;
    const total = priceCents(row.querySelector('._rsi-quantity-offers-new-price')?.textContent);
    const quantities = Array.from(row.querySelectorAll('input[name^="item_quantity["]'));
    const variants = Array.from(row.querySelectorAll('input[name^="item_variant_id["]'));
    if (quantities.length && quantities.length === variants.length) {
      let quantity = 0;
      for (const input of quantities) {
        const suffix = input.name.slice('item_quantity'.length);
        const variant = variants.find(candidate => candidate.name === 'item_variant_id' + suffix);
        const count = Number(input.value);
        if (!variant || variant.value !== '62790523813969' || !Number.isInteger(count) || count < 1) return null;
        quantity += count;
      }
      return total > 0 ? { variant: '62790523813969', quantity, total } : null;
    }
    if (requireInputs) return null;
    // Unselected rows have no transaction inputs. Their explicit quantity label
    // is only used to locate the native offer to click; verify its inputs after.
    const title = row.querySelector('._rsi-quantity-offers-title')?.textContent || '';
    const match = title.match(/\b(\d+)\s+(?:unidad(?:es)?|frascos?)\b/i);
    return match && total > 0 ? { variant: '62790523813969', quantity: Number(match[1]), total } : null;
  }
  function syncLandingFromOffer(row) {
    const actual = appOffer(row);
    const matches = Array.from(document.querySelectorAll('[data-lp-anchor="hero"] [data-lp-pack]')).filter(card => sameOffer(cardOffer(card), actual));
    if (matches.length !== 1) return false;
    if (matches[0].getAttribute('aria-pressed') !== 'true') matches[0].click();
    return sameOffer(selectedLandingOffer(), actual);
  }
  function verifyAppOffer(modal) {
    if (!offerMode()) return true;
    const dialog = modal.closest('#_rsi-cod-form-modal');
    if (!dialog?.classList.contains('_rsi-cod-form-modal-open')) return false;
    if (!offerSession) offerSession = { desired: selectedLandingOffer(), initial: true, manual: false, attempted: null };
    const selected = () => modal.querySelector(offerRowSelector + '._rsi-quantity-offers-selected');
    let actual = appOffer(selected());
    if (offerSession.initial && !offerSession.manual && offerSession.desired && !sameOffer(actual, offerSession.desired)) {
      const matches = Array.from(modal.querySelectorAll(offerRowSelector)).filter(row => sameOffer(appOffer(row, false), offerSession.desired));
      const target = matches.length === 1 && matches[0].querySelector('._rsi-quantity-offers-offer');
      if (target && offerSession.attempted !== target) {
        offerSession.attempted = target;
        try { forwardingOfferClick = true; target.click(); }
        finally { forwardingOfferClick = false; }
        actual = appOffer(selected());
      }
    }
    const verified = sameOffer(actual, selectedLandingOffer());
    if (verified) offerSession.initial = false;
    modal.dataset.brOfferSync = verified ? 'verified' : actual ? 'unmatched' : 'pending';
    return verified;
  }
  // Snapshot the selection at the real opening. Only native offer clicks are
  // used for a mismatch; app prices and transaction inputs are never rewritten.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-lp-cod-integration] [id="_rsi-buy-now-button-overwrite"]')) {
      offerSession = { desired: selectedLandingOffer(), initial: true, manual: false, attempted: null };
      schedule();
      return;
    }
    const offer = event.target.closest('#_rsi-cod-form-modal-form ' + offerRowSelector);
    if (!offer || forwardingOfferClick || !offerMode()) return;
    // Explicit app selection wins immediately over the opening snapshot, even
    // while the app's synchronous click handler is still replacing its inputs.
    if (offerSession) { offerSession.manual = true; offerSession.initial = false; }
    requestAnimationFrame(() => {
      if (!offer.isConnected || !offer.classList.contains('_rsi-quantity-offers-selected')) return;
      if (syncLandingFromOffer(offer) && offerSession) offerSession.desired = selectedLandingOffer();
      schedule();
    });
  }, true);
  // Remove decorative emoji in this landing's app dialog without altering inputs,
  // prices, selection, delivery conditions, validation or submission behavior.
  const emoji = /[\p{Extended_Pictographic}\p{Regional_Indicator}️‍]/gu;
  function cleanText(root) {
    if (!(root instanceof Element)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest('script,style,textarea,input,select,option') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const next = node.nodeValue.replace(emoji, '');
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }
  function presentation() {
    const modal = document.querySelector('#_rsi-cod-form-modal-form');
    if (modal) {
      const close = modal.querySelector('._rsi-modal-close-button');
      if (close && close.getAttribute('aria-label') !== 'Cerrar formulario') close.setAttribute('aria-label', 'Cerrar formulario');
      const selected = document.querySelector('[data-lp-anchor="hero"] [data-lp-pack][aria-pressed="true"]');
      const verified = verifyAppOffer(modal);
      const existingSummary = modal.querySelector('[data-br-order-summary]');
      if (existingSummary) {
        existingSummary.hidden = !verified;
        const display = verified ? '' : 'none';
        if (existingSummary.style.display !== display) existingSummary.style.display = display;
      }
      if (selected && verified) {
        const quantity = Number(selected.dataset.quantity);
        const price = selected.querySelector('[data-lp-card-total]')?.textContent.trim() || '';
        const title = 'NeoCell · ' + quantity + (quantity === 1 ? ' frasco de 567 g' : ' frascos de 567 g');
        let summary = modal.querySelector('[data-br-order-summary]');
        if (!summary) {
          summary = document.createElement('div');
          summary.className = 'br-modal-summary';
          summary.setAttribute('data-br-order-summary','');
          summary.setAttribute('aria-live','polite');
          const heading = document.createElement('strong');
          const total = document.createElement('span');
          summary.append(heading,total);
          const header = modal.querySelector('._rsi-modal-header');
          if (header) header.insertAdjacentElement('afterend',summary);
          else modal.prepend(summary);
        }
        if (summary.children[0].textContent !== title) summary.children[0].textContent = title;
        if (summary.children[1].textContent !== price) summary.children[1].textContent = price;
      }
    }
    const integration = document.querySelector('[data-lp-cod-integration]');
    if (integration) {
      const opener = integration.querySelector('#_rsi-buy-now-button-overwrite');
      if (opener) {
        cleanText(opener);
        const subtitle = opener.querySelector('._rsi-buy-now-button-subtitle');
        if (subtitle && subtitle.textContent !== 'COMPRA AQUÍ') subtitle.textContent = 'COMPRA AQUÍ';
        const icon = opener.querySelector('svg');
        if (icon && !icon.dataset.spCart) {
          icon.innerHTML = '<path d="M3 5h2l2.3 10.5h10.9L21 8H6"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/>';
          icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('fill','none');icon.setAttribute('stroke','currentColor');icon.setAttribute('stroke-width','1.7');icon.dataset.spCart='1';
        }
        if (!opener.hasAttribute('role')) { opener.setAttribute('role','button');opener.setAttribute('tabindex','0');opener.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();opener.click();}}); }
        const walker = document.createTreeWalker(opener, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (/Pedir y pagar al recibir|PIDE AHORA Y PAGA EN CASA/i.test(node.nodeValue) && node.nodeValue !== 'PIDE AHORA Y PAGA EN CASA') node.nodeValue = 'PIDE AHORA Y PAGA EN CASA';
        }
      }
    }
    document.querySelectorAll('#_rsi-cod-form-modal-form').forEach(cleanText);
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; presentation(); });
  };
  function syncFloatingOffer(bar) {
    if (!bar) return;
    const selected = selectedLandingOffer();
    if (!selected) return;
    const quantity = selected.quantity + (selected.quantity === 1 ? ' frasco' : ' frascos');
    const total = money.format(selected.total / 100);
    // Render all labels from one selected offer, without mixing new price and old text.
    const fields = [
      ['[data-sp-floating-offer]', quantity + ' · ' + total],
      ['[data-lp-selected-offer-summary]', quantity],
      ['[data-lp-price]', total]
    ];
    fields.forEach(([selector, value]) => {
      const node = bar.querySelector(selector);
      if (node && node.textContent !== value) node.textContent = value;
    });
  }
  function safeSticky() {
    const bar=document.querySelector('[data-sp-floating-buy]');if(!bar)return;
    const visible=el=>{if(!el||el.hidden||!el.getClientRects().length)return false;const style=getComputedStyle(el);if(style.visibility==='hidden'||style.display==='none')return false;const r=el.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth;};
    // Siempre visible; solo se oculta con el formulario abierto o mientras se escribe.
    const dialog=Array.from(document.querySelectorAll('#_rsi-cod-form-modal-form, dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active')).some(visible);
    const typing=document.activeElement?.matches('input,select,textarea,[contenteditable="true"]');
    const hide=dialog||typing;
    if(bar.hidden!==!!hide)bar.hidden=!!hide;
    if(!bar.hidden){const space=Math.ceil(innerHeight-bar.getBoundingClientRect().top)+12;const value=space+'px';if(space>40&&space<280&&document.body.style.getPropertyValue('--sp-fb-space')!==value)document.body.style.setProperty('--sp-fb-space',value);}
    syncFloatingOffer(bar);
  }
  document.addEventListener('lp:pack_select', () => {
    syncFloatingOffer(document.querySelector('[data-sp-floating-buy]'));
  });
  let stickyPending=false;
  const stickyQueue=()=>{if(stickyPending)return;stickyPending=true;requestAnimationFrame(()=>{stickyPending=false;safeSticky();});};
  ['scroll','resize','focusin','focusout'].forEach(event=>window.addEventListener(event,stickyQueue,{passive:true}));
  ['scroll','resize'].forEach(event=>window.visualViewport?.addEventListener(event,stickyQueue,{passive:true}));
  new MutationObserver(stickyQueue).observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','style','hidden','aria-pressed','open']});
  safeSticky();
  syncComparison();
  presentation();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', () => { syncComparison(); schedule(); });
})();
